import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Box, Container, Paper, ThemeProvider, Typography } from '@mui/material'
import gaiaTheme from '../../../root-components/theme'
import httpClient from '../../../shared/services/http/http-client'
import { CrpPlanDocument, ICrpPlanDocumentData } from '../../../components/presentation-components/reporting-components/crp/crp-plan-document'

/**
 * Read-only public view of a published Carbon Reduction Plan, rendered from the figures frozen when
 * the plan was generated, never live data. Reachable without signing in, so it holds nothing beyond
 * what the supplier chose to publish. The document itself is CrpPlanDocument, shared with the
 * signed-in plan view.
 */
export const PublicCrpPage = () => {
  const { shareId } = useParams()
  const [plan, setPlan] = useState<ICrpPlanDocumentData | null>(null)
  const [error, setError] = useState(false)

  useEffect(() => {
    if (!shareId) return
    httpClient.get(`public-report/crp/${shareId}`)
      .then((response) => setPlan(response.data))
      .catch((err) => {
        console.log(err)
        setError(true)
      })
  }, [shareId])

  if (error) {
    return (
      <ThemeProvider theme={gaiaTheme}>
        <Container maxWidth='sm' sx={{ mt: 6 }}>
          <Paper variant='outlined' sx={{ p: 4 }}>
            <Typography variant='h5' sx={{ mb: 2 }}>Not available</Typography>
            <Typography variant='body2' sx={{ color: 'text.secondary' }}>
              This Carbon Reduction Plan is no longer available. The link may have been disabled.
            </Typography>
          </Paper>
        </Container>
      </ThemeProvider>
    )
  }

  if (!plan) return null

  return (
    <ThemeProvider theme={gaiaTheme}>
      <Box sx={{ backgroundColor: 'background.default', minHeight: '100vh', py: 5 }}>
        <Container maxWidth='md'>
          <CrpPlanDocument plan={plan} />
        </Container>
      </Box>
    </ThemeProvider>
  )
}
